<script>
export default {
	name: "Row",
	components: {},
	props: { col: [String, Number] },
	data () {
		return {};
	},
	computed: {},
	watch: {},
	created () {
		window.ww = this;
	},
	mounted () {
	},
	updated () {
	},
	destroyed () {
	},

	methods: {},
	render (createElement) {
		return createElement("v-row", {
			attrs: Object.assign({ row: true }, this.$attrs),
		}, [this.$slots.default]);
	},
};
</script>

<style scoped>

</style>
